export default "__VITE_ASSET__9321f101__"